import React from 'react';
import { Box, Paper, Stack, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NS, PROFILE_KEYS } from '../../../i18n/constants/keys';
import { ComingSoonOverlay, SectionCard } from '../../../ui/mui';
import type { INotificationSetting } from '../interfaces';

interface INotificationsSectionProps {
  notifications: INotificationSetting[];
}

export const NotificationsSection = ({ notifications }: INotificationsSectionProps) => {
  const { t } = useTranslation(NS.profile);

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <SectionCard
        title={t(PROFILE_KEYS.sections.notifications.heading)}
        subtitle={t(PROFILE_KEYS.sections.notifications.intro)}
      >
        <ComingSoonOverlay label={t(PROFILE_KEYS.actions.comingSoon)}>
          <Stack spacing={1.5}>
            {notifications.map((notification) => (
              <Paper
                key={notification.id}
                variant="outlined"
                sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}
              >
                <Box>
                  <Typography variant="subtitle2">
                    {t(notification.labelKey)}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t(notification.descriptionKey)}
                  </Typography>
                </Box>
                <Switch checked={notification.enabled} disabled tabIndex={-1} inputProps={{ 'aria-label': t(notification.labelKey) }} />
              </Paper>
            ))}
          </Stack>
        </ComingSoonOverlay>
      </SectionCard>
    </Box>
  );
};
